import { writable, get } from "svelte/store";
import { DocumentService } from "$/services/DocumentService.js";
const store = () => {
    const { subscribe, set, update } = writable([]);
    return {
        subscribe,
        set,
        update,
        loadRecent: async (tenantId) => {
            const recent = await DocumentService.getRecentDocuments(tenantId);
            set(recent || []);
        },
        getDocumentName: async (tenantId, documentId) => {
            const state = get(DocumentStore);
            let document = state.find(doc => doc.id === documentId);
            if (!document)
                document = await DocumentService.getPrivateDocumentData(tenantId, documentId);
            return document ? document.name : null;
        },
        deleteDocument: async (tenantId, documentId) => {
            await DocumentService.deleteDocument(tenantId, documentId);
            update(state => state.filter((doc) => doc.id !== documentId));
        },
        countDocumentSnippets: async (documentId) => {
            const state = get(DocumentStore);
            let document = state.find((doc) => doc.id === documentId);
            if (document && document.snippetCount)
                return;
            let countSnippets = await DocumentService.countDocumentSnippets(documentId);
            update(state => state.map((doc) => doc.id === documentId ? Object.assign(Object.assign({}, doc), { snippetCount: countSnippets }) : doc));
        },
    };
};
export const DocumentStore = store();
